// extracted by mini-css-extract-plugin
module.exports = {"errorDescription":"ErrorDescription_errorDescription__j0IXc"};